import { ViewModel, View, ObservableArray } from "binder";
import { MachineTypeManipulationView } from "./machineTypeManipulation-view";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IMachineType } from "./IMachineType";
import { MachineTypeEditorViewModel, MachineTypeInserter, MachineTypeUpdater } from "./machineTypeEditor/machineTypeEditor-viewModel";

export class MachineTypeManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف نوع ماشین';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.machineTypes = ObservableArray.create<MachineType>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new MachineTypeManipulationView();
    }
    public getTypeId(): string {
        return "VM-9FA1F719-1585-4B49-9791-1665B3522CB7";
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set machineTypes(v: ObservableArray<MachineType>) { this._machineTypes = v; } public get machineTypes(): ObservableArray<MachineType> { return this._machineTypes; } private _machineTypes: ObservableArray<MachineType>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/MachineTypeServices/ListAllMachineTypes', {
                FilteringInformation: filteringInformation
            });
            this.machineTypes.update(...result.MachineTypes.map((x, i) => {
                let m = new MachineType(this);
                m.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                m.id = x.Id;
                m.name = x.Name;
                m.code = x.Code;
                return m;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new MachineTypeEditorViewModel(this, new MachineTypeInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(machineType: IMachineType) {
        let popup = new MachineTypeEditorViewModel(this, new MachineTypeUpdater());
        await machineType.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(machineType: MachineType): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/MachineTypeServices/DeleteMachineType", {
                    MachineTypeId: machineType.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class MachineType extends ViewModel implements IMachineType {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MachineTypeManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: MachineTypeManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;

    async cloneTo(machineType: IMachineType) {
        machineType.id = this.id;
        machineType.name = this.name;
        machineType.code = this.code;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
